import script from "./NotepadPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./NotepadPanel.vue?vue&type=script&setup=true&lang=js"

import "./panel.css?vue&type=style&index=0&id=78c02bab&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78c02bab"]])

export default __exports__